import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caret-right",
  "use": "icon-caret-right-usage",
  "viewBox": "0 0 192 512",
  "content": "<symbol aria-hidden=\"true\" class=\"svg-inline--fa fa-caret-right fa-w-6\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 512\" id=\"icon-caret-right\"><path fill=\"currentColor\" d=\"M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol